import { useTranslation } from "@opendash/i18n";
import { Select } from "antd";
import React, { useEffect, useState } from "react";
export const TimeSeriesMonthlyDay = ({ value, onChange, }) => {
    const t = useTranslation();
    const [currentValue, setCurrentValue] = useState(value);
    const options = [
        {
            label: t("maintenance:timeseries.monthly.day.first"),
            value: 1,
        },
        {
            label: t("maintenance:timeseries.monthly.day.second"),
            value: 2,
        },
        {
            label: t("maintenance:timeseries.monthly.day.third"),
            value: 3,
        },
        {
            label: t("maintenance:timeseries.monthly.day.fourth"),
            value: 4,
        },
        {
            label: t("maintenance:timeseries.monthly.day.last"),
            value: 5,
        },
    ];
    useEffect(() => {
        //Propagate the current Value on component activation/when it get's visible
        onChange(currentValue);
    }, []);
    return (React.createElement(Select, { style: { marginBottom: 24 }, defaultValue: currentValue, onChange: (v) => {
            onChange(v);
            setCurrentValue(v);
        }, options: options }));
};
//# sourceMappingURL=TimeSeriesMonthlyDay.js.map